module.exports = __webpack_public_path__ + "img/Tessellate05.9da29155.jpg";